import { Component, Inject, inject, signal, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { injectStripe, StripePaymentElementComponent } from 'ngx-stripe';
import { StripeElementsOptions, StripePaymentElementOptions, SetupIntent, StripeError } from '@stripe/stripe-js';  // Import SetupIntent from stripe-js
import { UserService } from 'src/app/services/user.service';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog'; // add 
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-add-card',
    templateUrl: './add-card.component.html',
    styleUrls: ['./add-card.component.scss'],
    standalone: false
})
export class AddCardComponent {
  @ViewChild(StripePaymentElementComponent)
  paymentElement!: StripePaymentElementComponent;
  client_secrets:any
  stripe:any

  private readonly fb = inject(UntypedFormBuilder);

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<AddCardComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.elementsOptions = {
      locale: 'en',
      clientSecret: data.client_secret,
      appearance: {
        theme: 'flat'
      }
    };
    this.initializeStripe()
  }
isElementLoaded = false;

  onElementReady() {
    this.isElementLoaded = true;
  }

  ngOnInit() {
    this.loadClientSecret()
  }
  elementsOptions: StripeElementsOptions = {};  
  paymentElementForm = this.fb.group({});
  paymentElementOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false, 
      radios: false,
      spacedAccordionItems: false
    }
  };

  initializeStripe() {
  const hostname = window.location.hostname;

  let connectedAccountId: string | null = null;

  if (hostname === environment.igniteDomain) {
    connectedAccountId = environment.stripeIgniteAccountID;

  } else if (hostname === environment.tune2Domain || hostname === environment.tune2Domain2) {
    connectedAccountId = environment.stripeTune2AccountID;
  }

  this.stripe = injectStripe(
    environment.stripePublicKey,
    connectedAccountId
      ? {
          stripeAccount: connectedAccountId
        }
      : {}
  );
}
  paying = signal(false);
  
  new_payment_method_is_loading = false;
  new_payment_method_is_adding = false;
  new_payment_method_error: string | null = null;
  new_payment_method_error_message: string | null = null;

  addPaymentMethod() {
    this.new_payment_method_is_loading = true;
    this.new_payment_method_is_adding = true;
    this.stripe
      .confirmSetup({
        elements: this.paymentElement.elements,
        redirect: 'if_required',
        confirmParams: {
          // return_url: 'http://localhost:4200/billing'
          return_url: 'https://app.pyrocast.com/billing'
        }
      })
      .subscribe({
        next: (result: { setupIntent?: SetupIntent; error?: StripeError }) => {
          if (result.error) {
            console.log('this.paymentElement.elements',this.paymentElement.elements);
            
            console.error('Error adding new payment method', result.error);
            if (
              (result.error.type === 'card_error' || result.error.type === 'validation_error') &&
              result.error.message !== 'incomplete_number'
            ) {
              this.new_payment_method_error = result.error.message ?? null;
            } else {
              this.new_payment_method_error_message = 'There was an issue adding the card';
            }
            this.new_payment_method_is_loading = false;
            this.new_payment_method_is_adding = false;
            return;
          }
          if (result.setupIntent) {
            console.log('result.setupIntent',result.setupIntent);
            setTimeout(() => {
              this.dialogRef.close({ paymentMethodAdded: true });
              this.getPaymentMethods();
            }, 500);

            setTimeout(() => {
              this.hideNewPaymentUI();
              this.new_payment_method_is_loading = false;
              this.new_payment_method_is_adding = false;
            }, 1500);
          }
        },
        error: (err:any) => {
          console.error('Error with payment method confirmation', err);
          this.new_payment_method_is_loading = false;
          this.new_payment_method_is_adding = false;
          this.new_payment_method_error_message = 'There was an error confirming the payment method.';
        }
      });

  }
  loadClientSecret() {
    this.userService.loadClientSecret().subscribe((response: any) => {
      console.log('response',response);
    });
  }
  getPaymentMethods() {
    // Add your logic to fetch payment methods if needed
  }

  hideNewPaymentUI() {
    // Add logic to hide UI or reset form if necessary
  }

  attachPaymentMethodToCustomer(paymentMethodId: string) {
    this.userService.addPaymentMethod(paymentMethodId).subscribe(response => {
      console.log('response',response);
      
      if (response.success) {
        alert('Payment method added successfully!');
      } else {
        alert('Failed to add payment method');
      }
    });
  }
}
